import { ContentResponse } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { config } from "JS/Config";

export class AudioService extends BaseService {
    getAudios = () =>
        this.ngCall<ContentResponse>(
            "get",
            appConstants.ngEndpoints.audioListing(config.user.memberId),
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );
}
